/* Local dependencies */
import wrapWithProvider from './src/redux/wrap-with-provider';

export const wrapRootElement = wrapWithProvider;
